import {Component, Input, OnInit} from '@angular/core';
import {Datasource, Source, SourceAccount, Token} from '../app.model';
import {CacheService} from '../cache.service';
import {AppService} from '../app.service';
import {Router} from '@angular/router';
import {CommonDialogComponent} from '../common-dialog/common-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { oldPricingRoute } from '../shared/namespaces';


@Component({
  selector: 'app-datasource-grid',
  templateUrl: './datasource-grid.component.html',
  styleUrls: ['./datasource-grid.component.scss']
})

export class DatasourceGridComponent implements OnInit {
  @Input() sources: Source[];
  userId: number;
  loggedIn = false;
  datasources: Datasource[] = [];
  filteredDatasources: Datasource[] = [];
  createSource: Source = new Source();
  accounts: SourceAccount[] = [];
  currentDatasourceType: String = '';
  userPlanSubscribed = false;
  categories: string[] = [];
  chosenCategory = 'all';
  searchText = '';
  baseWord: string = this.appService.getBaseWord();

  constructor(private cacheService: CacheService, private appService: AppService, private router: Router, private dialog: MatDialog) {
  }

  ngOnInit() {
    this.init();
    this.appService.getUserLoginEvent().subscribe({
      next: value => {
        if (value) {
          this.init();
        } else {
          this.loggedIn = false;
          this.createSource = new Source();
          this.accounts = [];
          this.currentDatasourceType = '';
          this.userId = 0;
        }
      }
    });
  }

  private init() {
    const saras_auth_key = this.cacheService.getObject<Token>('saras_auth_key');
    if (saras_auth_key) {
      this.loggedIn = true;
      this.userId = saras_auth_key.userId;
      this.getCurrentSubscriptionPlan();
      this.appService.getDataSources().then((datasources) => {
        this.datasources = datasources;
        this.filteredDatasources = datasources;
        datasources.forEach(datasource => {
          if (this.categories.indexOf(datasource.categoryName) === -1) {
            this.categories.push(datasource.categoryName);
          }
        });
      });
    } else {
      this.appService.routeToLogin();
    }
  }

  getCurrentSubscriptionPlan() {
    this.appService.getCurrentSubscriptionPlan(this.userId).then((data: any) => {
      if (!(data.body === null) && data.body.subscriptionPlanId) {
        this.userPlanSubscribed = true;
      }
    });
  }

  userDataSourceLogin(selectedDatasource: Datasource) {
    if (!(this.loggedIn /*&& this.userPlanSubscribed*/)) {
      this.appService.routeToLogin();
    } else {
      this.appService.userIntegrationLimit(this.userId, selectedDatasource.sourceId, true, 'addSource', 'add')
        .then(response => {
          // response is true if limit is reached
          if (!response.condition) {
            this.router.navigate(['/' + this.baseWord + '/add-source/' + selectedDatasource.sourceId])
              .catch(reason => console.error(JSON.stringify(reason)));
          } else {
            // change required buttons upgrade and later
            const dialogRef = this.dialog.open(CommonDialogComponent, {
              data: {
                title: '',
                content: response.message,
                image: 'warning',
                buttons: [
                  {
                    'title': 'OK',
                    'meta': '/integrations-list',
                    'type': 'no-change',
                    'class': 'confirm-dialog-later'
                  }
                ]
              },
              disableClose: true
            });

            dialogRef.afterClosed().subscribe(result => {
              this.router.navigate([oldPricingRoute]);
            });
          }
        });
    }
  }

  filterSources() {
    const tempSources = [];
    this.datasources.forEach(source => {
      source.displayName.indexOf(this.searchText);
      if ((source.displayName.trim().toLowerCase().indexOf(this.searchText.trim().toLowerCase()) >= 0 || this.searchText === '') &&
        ((source.categoryName.trim().toLowerCase().indexOf(this.chosenCategory.trim().toLowerCase()) >= 0)
          || (this.chosenCategory === 'all'))) {
        tempSources.push(source);
      }
    });
    this.filteredDatasources = tempSources;
  }
}
